enum HttpCode {
  SERVER_ERROR = 500,
  UNPROCESSABLE_ENTITY = 422,
  FORBIDDEN = 403
}

export {
  HttpCode
}